// extracted by mini-css-extract-plugin
module.exports = {"red__button":"style_red__button__16Ju4","full-width":"style_full-width__2p25W"};